<template>
    <xx-select
        v-model="innerValue"
        :list="innerUnitList"
        value-key="id"
        label-key="name"
        v-bind="$attrs"
        @change="onChange"
    />
</template>

<script>
export default {
    name: 'BaseUnitSelect',
    props: {
        value: {
            type: [Number, String, Array],
            required: true,
        },
        unitType: {
            type: [Number, String],
            default: 1,
        },
    },
    data() {
        return {
            unitList: [],
            innerValue: this.value,
        };
    },
    computed: {
        innerUnitList() {
            // 标品
            if (this.unitType === 1) return this.unitList.filter((item) => item.unitType === 1);
            // 散装 只能选择kg
            return this.unitList.filter((item) => item.name === 'kg');
        },
    },
    watch: {
        value(newVal) {
            this.innerValue = newVal;
        },
    },
    created() {
        this.getAllUnit();
    },
    methods: {
        // 消耗单位与基础单位 是否需要联动？老逻辑存在联动，但PRD未做梳理
        async getAllUnit() {
            const res = await this.$service.listAllUnit({ unitType: null }).catch(() => 'error');
            if (res === 'error') return;
            this.unitList = res.data;
        },
        onChange(id, item) {
            this.$emit('input', id);
            this.$emit('change', id, item || { id: '', name: '' });
        },
    },
};
</script>
